import React, { useRef, useState, useEffect, useCallback } from "react";
import screenfull from "screenfull";
import $ from "jquery";
import { isMobile as localIsMobile } from "./utils/ResponsiveUtils";
import InteractiveExperience from "./components/InteractiveExperience";
import "./App.css";

function App() {
  const CONTAINER_ID = "interactiveExperienceWrapper";
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(0);

  const getContainerHeight = useCallback(() => {
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const height = (containerRef.current.offsetWidth * 9) / 16;
    if (windowWidth / windowHeight <= 16 / 9) {
      setContainerHeight(height);
      $("#irobot-embedded-interactive-experience").removeClass(
        "embedded-aspect-ratio"
      );
      $(`#embedded-cleanslate`).removeClass("embedded-aspect-ratio");
    } else {
      setContainerHeight(windowHeight);
      $("#irobot-embedded-interactive-experience").addClass(
        "embedded-aspect-ratio"
      );
      $(`#embedded-cleanslate`).addClass("embedded-aspect-ratio");
    }
    setContainerHeight((containerRef.current.offsetWidth * 9) / 16);
  }, [containerRef, setContainerHeight]);

  const updateContainerHeight = useCallback(() => {
    setTimeout(() => {
      getContainerHeight();
    }, 500);
  }, [getContainerHeight]);

  useEffect(() => {
    window.addEventListener("resize", getContainerHeight);
    if (screenfull.isEnabled) {
      screenfull.on("change", updateContainerHeight);
    }
    return () => {
      if (screenfull.isEnabled) {
        screenfull.off("change", updateContainerHeight);
      }
      window.removeEventListener("resize", getContainerHeight);
    };
  }, [getContainerHeight, updateContainerHeight]);

  useEffect(() => {
    if (containerRef && containerRef.current) {
      getContainerHeight();
    }
    return () => {};
  }, [containerRef, getContainerHeight]);
  return (
    <>
      <div id="embedded-cleanslate" className="cleanslate">
        <div ref={containerRef} id={CONTAINER_ID}>
          <InteractiveExperience />
        </div>
        <style jsx="true">
          {`
            #${CONTAINER_ID} {
              background: #000000 !important;
              position: relative !important;
              overflow: hidden !important;
              width: 100% !important;
              height: ${containerHeight}px !important;
              max-height: 100vh !important;
              z-index: 1 !important;
            }

            .embedded-aspect-ratio {
              max-width: ${(window.innerHeight * 16) / 9}px !important;
              margin: auto !important;
            }

            *:fullscreen,
            *:-webkit-full-screen,
            *:-moz-full-screen {
              background-color: rgba(0, 0, 0, 0) !important;
            }

            @media screen and (orientation: portrait) {
              ${localIsMobile() &&
              `
              #${CONTAINER_ID} {
                height: 100% !important;
                min-height: 100vh !important;
              }
              #irobot-embedded-interactive-experience #embedded-cleanslate {
                height: 100% !important;
              }
            `}
            }

            ${!localIsMobile()
              ? `
              #irobot-embedded-interactive-experience:fullscreen {
                display: inline-flex;
                flex-direction: column;
                justify-content: center;
              }
            `
              : ""}
          `}
        </style>
      </div>
    </>
  );
}

export default App;
